module.exports = __webpack_public_path__ + "img/A2-3-icon.89084ebf.png";